/**
 * etichetteAccessi.js — come si chiamano, in italiano, i tipi di accesso
 * del registro degli accessi (colonna `azione` di accessi_log).
 *
 * UN ELENCO SOLO (24 settembre 2026, Alex): lo usano i riquadri «Ultimi 30
 * giorni» e «Per utente», l'elenco sotto e la tendina «Tipo di accesso».
 * Prima la schermata ne traduceva quattro e mostrava gli altri col nome
 * tecnico - «elenco_profilo», «contributi_procedure» - cioe' la parola
 * che il programma usa per se', non quella che dice a chi legge che cosa
 * e' stato guardato.
 *
 * Il nome tecnico resta la chiave: e' quello che si scrive nel registro e
 * che il filtro manda al server. Qui cambia solo cio' che si legge.
 *
 * UN TIPO NUOVO SENZA ETICHETTA non torna a mostrarsi tecnico: diventa
 * «Elenco profilo» (trattini tolti, maiuscola in testa). E' un ripiego,
 * non un'etichetta: chi aggiunge un'azione a `traccia()` la aggiunge qui.
 */
export const ETICHETTE_ACCESSI = {
    ricerca: 'Ricerca di pazienti',
    apertura_scheda: 'Apertura della scheda del paziente',
    apertura_scheda_tablet: 'Apertura della scheda dal tablet',
    elenco: 'Elenco di visite, documenti, foto o referti',
    voci: 'Lettura dell\'anamnesi',
    fisiologica: 'Anamnesi fisiologica',
    annotazioni: 'Mappa anatomica dell\'anamnesi',
    gravidanze_al: 'Gravidanze al giorno della visita',
    contributi_procedure: 'Testi delle procedure nell\'anamnesi (tolto il 24/09/2026)',
    elenco_profilo: 'Elenco delle schede del profilo',
    apertura_nel_profilo: 'Apertura di una scheda nel profilo',
    apertura_in_procedura: 'Apertura di una scheda in una procedura',
    avvisi: 'Avvisi delle schede cliniche',
    dettaglio_clinico: 'Dettaglio clinico di una procedura',
    moduli: 'Moduli di una procedura',
    integrazioni: 'Integrazioni di una visita',
    testo_precedente: 'Testo della visita precedente',
    lotti_da_indicare: 'Lotti da indicare in una procedura',
    consultazione_file: 'Apertura di un documento',
    apertura: 'Apertura di un questionario',
    andamento_peso: 'Andamento del peso',
    andamento: 'Andamento dei valori di un referto',
    stampa: 'Stampa',
    da_fatturare: 'Prestazioni da fatturare',
    mancate_presentazioni: 'Mancate presentazioni',
    esportazione: 'Esportazione dei dati',
    consultazione: 'Consultazione di un registro',
    riepilogo: 'Riepilogo del registro degli accessi',
    ripristino: 'Ripristino dal registro delle modifiche',
};

/** L'etichetta di un tipo di accesso, o il ripiego leggibile. */
export function etichettaAccesso(azione) {
    if (!azione) return '—';
    if (ETICHETTE_ACCESSI[azione]) return ETICHETTE_ACCESSI[azione];
    const t = String(azione).replace(/_/g, ' ').trim();
    return t.charAt(0).toUpperCase() + t.slice(1);
}

/* I ruoli come si leggono accanto a un nome. */
export const ETICHETTE_RUOLI = {
    admin: 'amministrazione',
    segreteria: 'segreteria',
    medico: 'medico',
    medico_senior: 'medico senior',
    acquisizione: 'acquisizione',
};

export const etichettaRuolo = (r) => (r ? (ETICHETTE_RUOLI[r] || String(r).replace(/_/g, ' ')) : 'ruolo non registrato');
